import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.DIRECTORS_CUT;

export const ITEMS_PER_ROUND = 6;
export const PROPS_PER_PAGE = 5;
export const EMOTIONS_PER_PAGE = 3;
export const TEXT_SCROLL_STEP = 33;
export const TEXT_LINE_COUNT = 13;
export const ONBOARDING_PHASE_INDEX_WITHOUT_TEXT = 2;
export const TOMATO_HIT_DURATION = 1600;
export const MIN_CANVAS_ITEM_SIZE = 48;
export const THOUGHT_BUBBLE = {
  HEIGHT: 106,
  WIDTH: 166,
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SET_FRAME_INDEX: 'SET_FRAME_INDEX',
  SET_DROP_ZONE: 'SET_DROP_ZONE',
  START_DRAG: 'START_DRAG',
  STOP_DRAG: 'STOP_DRAG',
  SET_IS_IN_DROP_ZONE: 'SET_IS_IN_DROP_ZONE',
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_DRAG_INDEX: 'SET_DRAG_INDEX',
  ADD_CHARACTER_TO_CANVAS: 'ADD_CHARACTER_TO_CANVAS',
  ADD_PROP_TO_CANVAS: 'ADD_PROP_TO_CANVAS',
  ADD_EMOTION_TO_CANVAS: 'ADD_EMOTION_TO_CANVAS',
  UPDATE_CHARACTER_POSITION: 'UPDATE_CHARACTER_POSITION',
  UPDATE_PROP_POSITION: 'UPDATE_PROP_POSITION',
  UPDATE_EMOTION_POSITION: 'UPDATE_EMOTION_POSITION',
  REMOVE_CHARACTER: 'REMOVE_CHARACTER',
  REMOVE_PROPS: 'REMOVE_PROPS',
  REMOVE_EMOTION: 'REMOVE_EMOTION',
  SET_CHARACTER_TAB_ID: 'SET_CHARACTER_TAB_ID',
  SET_PROPS_SCROLL_INDEX: 'SET_PROPS_SCROLL_INDEX',
  SET_EMOTIONS_SCROLL_INDEX: 'SET_EMOTIONS_SCROLL_INDEX',
  ROUND_END: 'ROUND_END',
  SET_GAME_MODE: 'SET_GAME_MODE',
  SET_IS_TABS_AREA_COLLAPSED: 'SET_IS_TABS_AREA_COLLAPSED',
  SET_IS_ACTION_BUTTON_HIDDEN: 'SET_IS_ACTION_BUTTON_HIDDEN',
  SET_IS_POPCORN_SHOWING: 'SET_IS_POPCORN_SHOWING',
  SET_TOMATOED_CHARACTER: 'SET_TOMATOED_CHARACTER',
  SET_TOMATOED_PROP: 'SET_TOMATOED_PROP',
  SET_TOMATOED_EMOTION: 'SET_TOMATOED_EMOTION',
  SET_IS_DIRECTOR_VISIBLE: 'SET_IS_DIRECTOR_VISIBLE',
  UPDATE_HINT: 'UPDATE_HINT',
  SET_CANVAS_DISABLED_ITEMS: 'SET_CANVAS_DISABLED_ITEMS',
  FOCUS_ELEMENT_ID: 'FOCUS_ELEMENT_ID',
  BLUR_ELEMENT_ID: 'BLUR_ELEMENT_ID',
  INCREASE_CORRECT_ANSWERS_COUNT: 'INCREASE_CORRECT_ANSWERS_COUNT',
  SET_IS_WRONG_ITEMS_TOMATOING: 'SET_IS_WRONG_ITEMS_TOMATOING',
  SET_IS_TRY_AGAIN_VISIBLE: 'SET_IS_TRY_AGAIN_VISIBLE',
  SET_CURRENT_STANDARD_ITEM_CHARACTER_TAB_ID: 'SET_CURRENT_STANDARD_ITEM_CHARACTER_TAB_ID',
  SAVE_FRAME_TO_HISTORY: 'SAVE_FRAME_TO_HISTORY',
  GOTO_HISTORY_ITEM: 'GOTO_HISTORY_ITEM',
  QUIT_HISTORY: 'QUIT_HISTORY',
  SHOW_HINT_ABOVE_TAB: 'SHOW_HINT_ABOVE_TAB',
  UPDATE_GAME_DATA: 'UPDATE_GAME_DATA',
  SET_ONBOARDING_PHASE_INDEX: 'SET_ONBOARDING_PHASE_INDEX',
  SET_WAS_CHARACTERS_START_ALERT_DISPLAYED: 'SET_WAS_CHARACTERS_START_ALERT_DISPLAYED',
  SET_WAS_THOUGHTS_START_ALERT_DISPLAYED: 'SET_WAS_THOUGHTS_START_ALERT_DISPLAYED',
  SET_HAS_VIEWED_ENTIRE_STORY_THIS_FRAME: 'SET_HAS_VIEWED_ENTIRE_STORY_THIS_FRAME',
  SET_VISITED_CHARACTER: 'SET_VISITED_CHARACTER',
  SET_ASSOCIATED_EMOTION_ID: 'SET_ASSOCIATED_EMOTION_ID',
  ASSOCIATE_EMOTION: 'ASSOCIATE_EMOTION',
  QUICK_PASS: 'QUICK_PASS',
  HIDE_BACK_BUTTON: 'HIDE_BACK_BUTTON',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
};

export const TABS = {
  CHARACTERS: 'CHARACTERS',
  PROPS: 'PROPS',
  EMOTIONS: 'EMOTIONS',
};

export const STORY_ELEMENTS = {
  CHARACTER: 'CHARACTER',
  PROP: 'PROP',
  EMOTION: 'EMOTION',
};

export const GAME_MODES = {
  FEEDBACK_POSITIVE: 'FEEDBACK_POSITIVE', // Student just answered a question correctly
  FEEDBACK_NEGATIVE: 'FEEDBACK_NEGATIVE', // Student just answered a question incorrectly
  STANDARD: 'STANDARD',
  ASSOCIATE_EMOTION_BUBBLE: 'ASSOCIATE_EMOTION_BUBBLE',
};

export const WORKFLOW = {
  QUEST: 'QUEST',
  PRACTICE: 'PRACTICE',
};

export const AVAILABLE_LEVEL_INDEXES = [0, 1, 2, 3, 4, 5];
